/**
 * Spec 247 — GEO Observatory's app mark (Kridt `.hub-mark`).
 *
 * "One glyph per app, everywhere": the sidebar brand, the sign-in sheet,
 * Orbit's catalog and the favicon all show `bx-radar` on an ink tile. The
 * catalog and favicon use the same glyph as a real SVG at
 * `client/public/assets/icon.svg`, because they cannot load the icon font.
 */
export const APP_NAME = 'GEO Observatory';
export const APP_GLYPH = 'bx-radar';

export function AppMark({ large = false }: { large?: boolean }) {
  return (
    <span className={`hub-mark${large ? ' hub-mark--lg' : ''}`} aria-hidden="true">
      <i className={`bx ${APP_GLYPH}`} />
    </span>
  );
}
